import React from "react";
import "./PickemCheckbox.scss";
import { Icon } from "components/common/Icons/Icon";

const PickemCheckbox = ({
    inputData,
    onChange,
    onKeyPress,
    className,
    focus,
    code,
    defaultValue,
    onClick
}) => {
    const { id, name, value, checked } = inputData;

    const handleChange = ({ target: { value, checked } }) => {
        console.log("Handle Change:", value)
        onChange && onChange(value, checked, inputData);
    };

    //useEffect(() => {
    //    if (focus) {
    //        document.getElementById(id)?.focus();
    //    }
    //});

    const isSimpleSelect =
        className && className === "simple-select" ? true : false;

    return (
        <span className={`PickemCheckbox ${className || ""}`}>
            <input
                id={id}
                name={name}
                value={value}
                checked={checked}
                type="checkbox"
                className="PickemCheckbox-input"
                onKeyPress={onKeyPress}
                onChange={handleChange}
                onClick={onClick || null}
                data-key={code || ""}
                data-default={defaultValue || ""}
            />
            <label htmlFor={id} className="PickemCheckbox-label">
                {!isSimpleSelect ? (
                    <Icon name={checked ? "check" : "unchecked"} />
                ) : checked ? (
                    <Icon name="checkMark" />
                ) : null}
            </label>
        </span>
    );
};

export default PickemCheckbox;
